import { LocationTypes } from "../types";
import EncryptionAdapter from "../adapters/EncryptionAdapter";
import IPFSStorageAdapter from "../adapters/IPFSStorageAdapter";
import JsonSerializerAdapter from "../adapters/JsonSerializerAdapter";
import LocalStorageAdapter from "../adapters/LocalStorageAdapter";
function storageAdapterFactory(config, lexiWallet) {
    let adapter;
    switch (config.locationType) {
        case LocationTypes.IPFS:
            adapter = new IPFSStorageAdapter();
            break;
        case LocationTypes.LOCAL_STORAGE:
            adapter = new LocalStorageAdapter();
            break;
        default:
            throw new Error("Unsupported storage location");
    }
    if (config.encrypted) {
        if (lexiWallet !== null) {
            adapter = new EncryptionAdapter(adapter, lexiWallet);
        }
        else {
            throw new Error("Invalid settings passed for encryption");
        }
    }
    return new JsonSerializerAdapter(adapter);
}
export default storageAdapterFactory;
